export default "__VITE_PUBLIC_ASSET__647a7022__"